// extracted by mini-css-extract-plugin
export default {"total":"bookings_total-module___total___dddfb9e8","icon":"bookings_total-module___icon___fabd399c"};